<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height main_background" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4" lg="3">
            <v-card class="elevation-12">
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="username/email"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" small outlined @click="$router.go(-1)">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" small outlined to="/Login">Submit</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String
  }
};
</script>